import React from 'react'
import { connect } from 'react-redux'
//import { FormattedMessage } from 'react-intl'
import * as _ from 'recompose'

//import PaymentCard from './Card'
//import RadioSvg from '../../../components/Icons/RadioSvg'
import { setPaymentData } from '../../../store/reducers/paymentMethods'
import numeral from 'numeral'

import GiftCard from './GiftCard'
import Checkbox from './../../Checkbox'

const GiftCardsMethod = ({
  title,
  name,
  isConfirmed = false,
  withVisual = false,
  cards = [],
  onClick,
  onClickCard,
  onChange,
  selected,
  sendBack,
  bidInputFocus,
  setBidInputFocus,
  type,
  pin, number, 
  useGiftCard,
  giftCardChecked, setGiftCardChecked,
  setAgreementGiftcard,  giftCardShow, setGiftCardShow, giftcardBalance,
}) => {
function setShowFunc() {
  if (giftCardShow) {
    setGiftCardChecked(false)
    setAgreementGiftcard(false)
  }
  setGiftCardShow(!giftCardShow)  
}
return(
  <div>
  <div className='PaymentMethod' /*onClick={()=>onClick(cards)}*/>{/*метод оплаты */}
    <div className='PaymentMethod__header'>
      <div className='GiftCardPayment-control Text'>
        <div className='Main__control'>
          <Checkbox isLight checked={giftCardShow} onChange={setShowFunc} />
        </div>
        <span className='Main__control-label'>
          Есть подарочный сертификат
        </span>
      </div>
      {/*<div className='PaymentMethod__radio'>
        <RadioSvg checked={selected} />
      </div>
      <div className='PaymentMethod__title'>
        Оплата подарочной картой
        {(isConfirmed && !withVisual) && <span className='PaymentMethod__activated'><FormattedMessage id='bidPayment.activated' /></span>}
      </div>*/}
    </div>
    <div className='PaymentMethod__text'>{giftCardChecked && <div>Баланс подарочного сертификата - {(giftcardBalance !== undefined ) && numeral(giftcardBalance).format('0,0')} рублей</div>}</div>
    </div>
    {giftCardShow && <GiftCard onChange={onChange} currentMethod="giftcard" onClickGift={onClickCard} sendBack={sendBack} bidInputFocus={bidInputFocus} 
    setBidInputFocus={setBidInputFocus} useGiftCard={useGiftCard} giftCardChecked={giftCardChecked} setGiftCardChecked={setGiftCardChecked}/>}
      {/*<div className="GiftCardPayment__row">
        <div className="GiftCardPayment__number">
          <input
            type='number'
            className="Form__field Form__field-number"
            value={number}
            placeholder="№ сертификата"
            onInput={setData('number')}
          />
        </div>
        <div className="GiftCardPayment__pin">
          <input
            type='number'
            className="Form__field Form__field-number"
            value={pin}
            placeholder="Пин-код"
            onInput={setData('pin')}
          />
        </div>
        <div className="GiftCardPayment__use">
          Использовать
    </div>
      </div>*/}
    {/* (/*(isConfirmed && withVisual) && /
      <div className='PaymentMethod__content'>
        <div className='PaymentCards'>{/*платежная карта - смена карты и плат системы /}
            <div >
              <GiftCard onChange={onChange} currentMethod="giftcard" onClickGift={onClickCard} sendBack={sendBack} bidInputFocus={bidInputFocus} setBidInputFocus={setBidInputFocus}/>
            </div>
        </div>
      </div>
    )*/}
  </div>
)}

const mapState = (state, { name, type }) => ({
  ...state.paymentMethods.methods[name],
  type: type,
  selected: state.paymentMethods.data.paymentMethod === name
})

const mapDispatch = (dispatch, props) => ({
  onClick: (cards) => {//нажатие на плат систему
    dispatch(setPaymentData('paymentMethod', props.name))//меняем плат систему
    dispatch(setPaymentData('userPaymentId', "giftcard"))//меняем карту в соответствии 
    props.onChange('paymentMethod', props.name)
    props.onChange('userPaymentId', "giftcard")
  },
  onClickCard: () => {//нажатие на карту
    dispatch(setPaymentData('paymentMethod', props.name))//меняем плат систему, карта меняется в Card.js по onChange
    props.onChange('paymentMethod', props.name)
  },
})

export default _.compose(
  connect(mapState, mapDispatch),
  _.withHandlers({
    initCard: (props) => async e => {//при открытии компонента, нужно выбрать карту (в соответствии с уже выбранной плат системой)
      e && e.preventDefault()
      props.onClick(props.cards)
    }
  }),
  _.lifecycle({
    componentDidMount () {
      //this.props.onClick()
      this.props.initCard()
    }
  })
)(GiftCardsMethod)




// WEBPACK FOOTER //
// ./src/components/Lot/PaymentSelect/GiftCardsMethod.js